<!-- 关于我们 -->
<template>
  <div class="joinbox">
    <div class="banxin">
      <div class="logobtns">
        <h1 class="logo" @click="goHome"></h1>
        <!-- <button class="regbtn"  @click="goRecharge()">Recharge</button>  -->
        <div style="position:absolute;right:20px">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              Language<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="cn">中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
              <el-dropdown-item command="in">Indonesian</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <h1>About Us</h1>
      <div class="privacy">
        <div>
          <span>{{ language.t1 }}</span>
          <span>{{ language.t2 }}</span>
          <span>{{ language.t3 }}</span>
          <span></span>
          <p>{{ language.concat }}</p>
          <p>{{ language.agent }} :</p>
          <span class="m"><a href="mailto:jasonhe@mangolive.net ">jasonhe@mangolive.net </a> ({{ language.region
          }})</span>
          <span class="m"> <a href="mailto:global.bd@mangolive.net ">global.bd@mangolive.net </a> ({{ language.region2
          }})</span>
          <p>{{ language.service }} : <a href="mailto:customerservice@mangolive.net ">customerservice@mangolive.net </a>
          </p>
          <p>{{ language.businessCooperation }} : <a href="mailto:eveyin@mangolive.net ">eveyin@mangolive.net</a></p>
          <p>{{ language.techSupport }} : <a href="mailto:developer@mangolive.net">developer@mangolive.net</a></p>
          <p>{{ language.facebook }} : <a
              href="https://www.facebook.com/mangolive.in">https://www.facebook.com/mangolive.in</a></p>
          <p></p>
        </div>
      </div>
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>
<script>
import { aboutUsLanguage } from '../../common/js/language'
export default {
  data() {
    return {
      isuser: true,
      dom: "",
      country: localStorage.getItem("country") || "EN",
      language: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    goHome() {
      window.location.href = 'https://yogurtlive.me/'
    },
    getData() {
      let { country } = this;
      if (country == "in") {
        this.language = aboutUsLanguage.IN
      } else if (country == "cn") {
        this.language = aboutUsLanguage.ZH
      } else {
        this.language = aboutUsLanguage.EN
      }
    },
    handleCommand(command) {
      window.localStorage.setItem("country", command);
      // window.localStorage.removeItem("router");
      this.$router.go(0);
    },
  },
};
</script>
<style lang="less" scoped>
@media screen and (min-width: 900px) {
  .joinbox {
    background: #fff;
    font-size: 0.09rem;
    line-height: 0.17rem;
  }

  .logobtns {
    width: 100%;
    height: 0.42rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;

    .logo {
      width: 1.04rem;
      height: 0.2rem;
      background: url("../../assets/images/liveimg/LOGO_phone@2x.png");
      background-size: 100% 100%;
    }
  }

  h1 {
    font-size: 0.15rem;
    margin: 0.1rem 0 0.08rem 0;
  }

  p {
    margin-top: 0.1rem;
  }

  span {
    box-sizing: border-box;
    display: block;
  }

  /deep/ .privacy {
    header {
      font-size: 0.2rem;
      text-align: center;
      line-height: 0.6rem;
      font-weight: 700;
    }

    h1 {
      font-size: 0.13rem;
      line-height: 0.4rem;
    }

    p {
      font-size: 0.11rem;
      line-height: 0.2rem;
      // margin-bottom: 0.2rem;
      font-weight: 600;
      word-wrap: break-word;
      word-break: normal;


    }

    a {
      font-weight: 500;
      color: blue;
    }

    span {
      display: block;
      font-size: 0.11rem;
      margin-top: 0.2rem;
      word-break: normal;
      word-wrap: break-word;
      white-space: pre-wrap;

      &.m {
        margin-top: 0.1rem;
      }
    }
  }
}

@media screen and (max-width: 899px) {
  .joinbox {
    background: #fff;
    font-size: 0.3rem;
    line-height: 0.45rem;
  }

  .banxin {
    width: 80%;
  }

  .logobtns {
    width: 100%;
    height: 0.8rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;

    .logo {
      width: 3.46rem;
      height: 0.6rem;
      background: url("../../assets/images/liveimg/LOGO_phone@2x.png");
      background-size: 100% 100%;
    }
  }

  h1 {
    font-size: 0.4rem;
    margin: 0.5rem 0 0.2rem 0;
  }

  p {
    margin-top: 0.3rem;
  }

  span {
    box-sizing: border-box;
    display: block;
    // padding-left: 0.4rem;
  }

  /deep/ .privacy {
    header {
      font-size: 0.4rem;
      text-align: center;
      line-height: 1rem;
      font-weight: 700;
    }

    h1 {
      font-size: 0.3rem;
      line-height: 0.8rem;
    }

    p {
      word-wrap: break-word;
      word-break: normal;
      font-size: 0.32rem;
      font-weight: 600;
      line-height: 0.5rem;
      margin-bottom: 0.2rem;
    }

    a {
      font-weight: 500;
      color: blue;
      display: block;
      font-size: 0.32rem;
    }

    span {
      margin-bottom: 0.2rem;
      display: block;
      margin-top: 0.2rem;
      word-break: normal;
      word-wrap: break-word;
      white-space: pre-wrap;
      font-size: 0.32rem;

      &.m {
        margin-top: 0.1rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/webpage/aboutus.vue